import { Button } from '../../components/Form/Button';
import { QuantityInput } from '../../components/Form/QuantityInput';
import { Icon, trash } from '../../components/Icon/Icon';
import { Img } from '../../components/Img/Img';
import { PriceTagSimple } from '../../components/PriceTagSimple/PriceTagSimple';
import { DeliveryTime } from '../../components/product/DeliveryTime';
import { useTranslation } from '../../i18n/i18n';
import { Link } from 'react-router-dom';
import { ApiOrderItem } from '../../types';
import './EditOrderItem.css';
import { ProductContainer } from '../../state/product';

export const EditOrderItem = ({
	item,
	index,
	onDelete,
	onChange,
}: {
	item: ApiOrderItem;
	index: number;
	onDelete: (id: number, i: number) => void;
	onChange: (value: number, i: number) => void;
}): JSX.Element => {
	const t = useTranslation().cart;
	const { getFinalPrice } = ProductContainer.useContainer();

	const {
		image,
		quantity,
		product: { id, name, bundleSize, finalPrice, tax, perma },
	} = item;

	return (
		<edit-order-item>
			<Img src={image} width={292} height={292} alt={name} />
			<div className="title">
				<Link to={'/' + perma}>{name}</Link>
			</div>
			<QuantityInput
				defaultValue={quantity}
				onBlur={(value) => onChange(value, index)}
				step={bundleSize}
				iconSize={17}
			/>

			<span className="delivery">
				<DeliveryTime deliveryClass={1} textLength={'short-one-line'} />
			</span>
			<Button
				className="clear"
				onClick={() => {
					onDelete(item.id, index);
				}}
			>
				<Icon shape={trash} size={16} /> {t.remove}
			</Button>
			<div className="item-price">
				<PriceTagSimple
					price={getFinalPrice(id, finalPrice, quantity)}
					// isCampaign={item.price.special ? true : false}
					vatRate={tax * 100}
				></PriceTagSimple>
			</div>
		</edit-order-item>
	);
};
